import React, { useMemo } from 'react';

import { MembershipItemFragment, MembershipFilter } from '@occc/graphql';
import { useGetMemberships } from '@occc-app/dataAccessLayer/membership/queries';
import { useChainId } from '@occc-app/Chain/hooks';
import { PaginationInfo } from '@occc-app/hooks/usePaginatedQuery';

import { MembersTable } from './MembersTable';
import { sanitizePhoneNumberInFilterTextIfPresent } from './utils';

interface IMembersTableContainerProps {
  filterText?: string;
  onClickMember: (member: MembershipItemFragment) => void;
  paginationInfo: PaginationInfo;
  onPageChange: (info: PaginationInfo) => void;
}

export const MembersTableContainer: React.FC<IMembersTableContainerProps> = ({
  onClickMember,
  filterText,
  paginationInfo,
  onPageChange,
}) => {
  const chainId = useChainId();
  const filter: MembershipFilter = useMemo(
    () => ({
      search: sanitizePhoneNumberInFilterTextIfPresent(filterText),
      chainIdEquals: chainId || undefined,
    }),
    [filterText, chainId],
  );

  const { loading, error, data, paginationProps } = useGetMemberships({
    filter,
    paginationInfo,
    onPageChange,
  });

  return (
    <MembersTable
      data={data}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
      onClickMember={onClickMember}
    />
  );
};
